export default "__VITE_ASSET__YZ7j5ZbW__"